import { isEmpty } from 'ramda'

export const hasValue = v => v !== undefined && !isEmpty(v)
